const controllersBySessionId = new Map<string, AbortController>();

export function startPendingConsentReplay(sessionId: string): AbortController {
  abortPendingConsentReplay(sessionId);
  const controller = new AbortController();
  controllersBySessionId.set(sessionId, controller);
  return controller;
}

export function finishPendingConsentReplay(
  sessionId: string,
  controller: AbortController
): void {
  if (controllersBySessionId.get(sessionId) === controller) {
    controllersBySessionId.delete(sessionId);
  }
}

export function abortPendingConsentReplay(sessionId: string): void {
  const controller = controllersBySessionId.get(sessionId);
  if (!controller) {
    return;
  }
  controller.abort();
  controllersBySessionId.delete(sessionId);
}

export function abortAllPendingConsentReplays(): void {
  controllersBySessionId.forEach((controller) => controller.abort());
  controllersBySessionId.clear();
}
